import axiosInstance from '../utils/axiosInstance';
import { JsonBuilderService } from './JsonBuilderService';
import axios from "axios";


interface Location {
  name: string;
  region: string;
  country: string;
  lat: number;
  lon: number;
  tz_id: string;
  localtime_epoch: number;
  localtime: string;
}

interface Condition {
  text: string;
  icon: string;
  code: number;
}

interface AirQuality {
  co: number;
  no2: number;
  o3: number;
  so2: number;
  pm2_5: number;
  pm10: number;
  'us-epa-index': number;
  'gb-defra-index': number;
}

interface Current {
  last_updated_epoch: number;
  last_updated: string;
  temp_c: number;
  temp_f: number;
  is_day: number;
  condition: Condition;
  wind_mph: number;
  wind_kph: number;
  wind_degree: number;
  wind_dir: string;
  pressure_mb: number;
  pressure_in: number;
  precip_mm: number;
  precip_in: number;
  humidity: number;
  cloud: number;
  feelslike_c: number;
  feelslike_f: number;
  vis_km: number;
  vis_miles: number;
  uv: number;
  air_quality: AirQuality;
}

interface WeatherData {
  location: Location;
  current: Current;
}

// hanlder for builder only
const handleAsync = async (asyncFn: Function, appId?: string) => {
  try {
    return await asyncFn();
  } catch (error: any) {
    if (error.response && error.response.status === 401) {
      console.log("401 error redirecting:", error);
      window.location.reload();
    }
    throw error; // Propagate the error
  }
};

class BuilderService {
  //  public _jsonBuilderService: JsonBuilderService;
  _jsonBuilderService = new JsonBuilderService();


  getWeather = async (location: string): Promise<WeatherData> => {
    return handleAsync(() =>
      axiosInstance.get<WeatherData>(`agents/weatherApi?location=${location}`)
    ).then((response) => response.data);
  };

  createAppByAI = (data: object): Promise<any> => {
    return handleAsync(() =>
      axiosInstance.post(
        `builder/create_app_by_AI`,
        data
      )
      ).then(res=>res.data);
  };
  fetchAppbyUrl = async (url: any): Promise<any> => {
      const response = await axiosInstance.get(`builder/get_app/${url}`);
      return response.data;
  };



fetchAppDatabyUrl = async (url: string, params?: {
  page?: number;
  limit?: number;
  startDate?: string;
  endDate?: string;
}): Promise<any> => {
  const queryParams = new URLSearchParams();
  
  if (params?.page) {
    queryParams.append('page', params.page.toString());
  }
  
  if (params?.limit) {
    queryParams.append('limit', params.limit.toString());
  }
  
  if (params?.startDate) {
    queryParams.append('startDate', params.startDate);
  }
  
  if (params?.endDate) {
    queryParams.append('endDate', params.endDate);
  }
  
  const queryString = queryParams.toString();
  const endpoint = `builder/get_app_data/${url}${queryString ? `?${queryString}` : ''}`;
  
  const response = await axiosInstance.get(endpoint);
  return response.data;
};


deleteAppDatabyURL = async(id: string): Promise<any> => {
  return axiosInstance.delete(`builder/delete_app_data/${id}`);
};

deleteAppSelectedDatabyURL = async (ids: string[]):Promise<any>=>{
  return axiosInstance.delete(`builder/delete_selected_app_data`,{
    data:{ids}
  });
}

updateAppDatabyURl = async (id: string, updatedData: any) => {
  return await axiosInstance.put(`builder/update_app_data/${id}`, updatedData);
};


  updateApp = (appId: any, data: any): Promise<any> => {
    return handleAsync(() =>
      axiosInstance.post(`builder/update_app/${appId}`, data)
    );
  };
  getAllCalc = (): Promise<any> => {
    return handleAsync(() =>
      axiosInstance.get(`builder/get_all_apps`, {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
      })
    ).then(res => res.data)
    .catch(error => {
      if (error.response && error.response.status === 401) {
        // Redirect to the specified URL if the status code is 401
        console.log('error getall app', error);
        // window.location.href = `${process.env.REACT_APP_REDIRECT_URL}`;
      } 
    });
  };


  deleteParticularCalc = (appId: string): Promise<any> => {
    return handleAsync(
      () => axiosInstance.delete(`builder/delete_app/${appId}`).then(res => res.data),
      appId
    )
  };
  getAllLocation = (locationName: string): Promise<any> => {
    return handleAsync(() =>
      axiosInstance.get(`agents/locationSearch/${locationName}`).then(res=>res.data)
    );

  };

  checkUniqueAppName = async (body:any): Promise<any> => {
    try {
        return await axiosInstance.post(`builder/check_unique_app_name`,body);
    } catch (error:any) {
      if (error.response && error.response.status === 401) {
        console.log("unique name error:", error)
        window.location.reload();
      }
        throw error;
    }
};
checkUniqueAppUrl= async (body:any): Promise<any> => {
  try {
      return await axiosInstance.post(`builder/check_unique_url`,body).then((res) => res.data);;
  } catch (error) {
      throw error;
  }
};
  createUser = async (data: any): Promise<any> => {
    const response = await axiosInstance.post(`builder/create_user`,data);
    return response.data;
    // return handleAsync(() =>
    //   axiosInstance.post(`builder/create_user`, data,
    //   ).then(res => res.data)
    // );
  };

  fixError = async (data: any): Promise<any> => {
    return handleAsync(() =>
      axiosInstance.post(`builder/fixError`, data,
      ).then(res => res.data)
    );
  };

  enhanceTool = async (data: any): Promise<any> => {
    return handleAsync(() =>
      axiosInstance.post(`builder/tool_enhance`, data,
      ).then(res => res.data)
    );
  };
  enhancePrompt = async (prompt:string): Promise<any> => {
    return handleAsync(() => axiosInstance.post(`builder/enhancePrompt`,{prompt}))
 };
 validatePrompt=async (prompt:string): Promise<any> => {
  return handleAsync(() =>
    axiosInstance.post(`builder/validatePrompt`,{prompt}
    ).then(res => res.data)
  );
}

  liveApp=(appId:string,data:any)=>{
    return handleAsync(() =>
      axiosInstance.post(
        `builder/liveApp/${appId}`,
      {data}
      )
      ).then(res=>res.data);
  }

  changeAppStatus=(appId:string)=>{
    return handleAsync(() =>
      axiosInstance.post(
        `builder/changeAppStatus`,
        {appId}
      )
    ).then(res => {
      if (res && res.data) {
        return {
          success: true,
          message: res.data.message || "App status changed successfully"
        };
      }
      return {
        success: false,
        message: "Failed to change app status"
      };
    }).catch(error => {
      if (error.response) {
        // Handle specific error cases from backend
        if (error.response.status === 404) {
          if (error.response.data.message === "AppId not valid") {
            throw new Error("Invalid app ID");
          } else if (error.response.data.message === "App not found") {
            throw new Error("App not found");
          }
        }
      }
      throw error;
    });
  }

  getUser = async (): Promise<any> => {
    // return handleAsync(() =>
    //   axiosInstance.get(`builder/get_user`, 
    //   ).then(res => res.data)
    // );
    // try{
      const response = await axiosInstance.get(`builder/get_user`);
      return response.data;
    // }
    // catch(error){
    //   console.log("error:",error)
    // }
  }
  
  
  
  fetchVisitors = (data: any): Promise<any> => {
    return handleAsync(() =>
      axiosInstance.post(`analytic/get_engagements`,data)
    ).then((res) => res.data);
  };
  updateUserChatLimits = async (): Promise<any> => {
    return handleAsync(() =>
      axiosInstance.post('builder/update_user')
    ).then(res => {
      // Return the entire response since we need both message and data
      return res.data;
    })
    .catch(error => {
      console.error('Error updating chat limits:', error);
      throw error;
    });
  };

  updateUserPlanSubscription = async (planId: string): Promise<any> => {
    return handleAsync(() =>
      axiosInstance.post('builder/update_userplan', { planId })
    ).then(res => {
      return res.data;
    })
    .catch(error => {
      console.error('Error updating user plan:', error);
      throw error;
    });
  };

  // Add this method to your BuilderService class
getAllPlans = async (): Promise<any> => {
  return handleAsync(() =>
    axiosInstance.get('builder/tlplans')
  ).then(res => {
    return res.data;
  })
  .catch(error => {
    console.error('Error fetching plans:', error);
    throw error;
  });
};
  getLeads = (data: any): Promise<any> => {
    return handleAsync(() =>
      axiosInstance.post(`analytic/get_leads`,data)
    ).then((res) => res.data);
  };
  deleteVisitors = (body: any): Promise<any> => {
    return handleAsync(() =>
      axiosInstance.post(`analytic/delete_visits`,body)
    ).then((res) => res.data);
  };

  deleteLeads = (body: any): Promise<any> => {
    return handleAsync(() =>
      axiosInstance.post(`analytic/delete_leads`,body)
    ).then((res) => res.data);
  };

  getPreviewApp=(appId:any)=>{
    return handleAsync(() =>
      axiosInstance.get(`builder/getPreviewApp/${appId}`)
    ).then((res) => res.data);
  };
  getOverViewDetails=(appId:any)=>{
    return handleAsync(() =>
      axiosInstance.get(`builder/getOverView/${appId}`)
    ).then((res) => res.data);
  };

  runBrandGuide = async (domain:string,brand_type:string): Promise<any> => {
    return handleAsync(() =>
      axiosInstance.post(`builder/brand_guide`, {domain,brand_type},
      ).then(res => res.data)
    );
  }

  uploadFileAWS = async (image:FormData): Promise<any> => {
    console.log("image11:",image)
    try{
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}builder/upload_file_aws`, image, {
        withCredentials: true,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
        console.log("error:",error)
    }
  }
  //upload_file_aws_leadForm
  uploadFileAWS_leadForm = async (formData: FormData): Promise<any> => {
    try {
      // Log the actual file from FormData
      const file = formData.get('file');
      console.log("File from FormData:", file);

      if (!file) {
        throw new Error('No file provided');
      }

      // Create a new FormData instance to ensure proper transmission
      const newFormData = new FormData();
      newFormData.append('file', file);


      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}builder/upload_file_aws_leadForm`, newFormData, {
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });


      if (!response.data || !response.data.data) {
        throw new Error('Invalid response from server');
      }

      return response.data;
    } catch (error: any) {
      console.log("Upload error details:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        headers: error.response?.headers
      });
      
      // Throw a more specific error
      if (error.response?.data?.error) {
        throw new Error(error.response.data.error.message || 'Upload failed');
      }
      throw error;
    }
  }
  uploadFileAWSULILT = async (image:FormData,appURL:any): Promise<any> => {

    try{
      image.append("appURL", appURL); 
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}builder/upload_file_aws_ULILT`, image, {
        withCredentials: true,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
      });
     
      return response.data;
    } catch (error) {
        console.log("error:",error)
    }
  }
  updateBrandGuide = async (data: any): Promise<any> => {
    return handleAsync(() =>
      axiosInstance.patch(`builder/update_brand_guide`, data,
      ).then(res => res.data)
    );
  }

  getcalculatorStats=async (data:any): Promise<any> => {
    return handleAsync(() =>
      axiosInstance.post(`analytic/calculator_stats`, data
      ).then(res => res.data)
    );
  }

  //payment
  stripePayment=async (data:any): Promise<any> => {
    return handleAsync(() =>
      axiosInstance.post(`builder/create_stripe_checkout_session`, data
      ).then(res => res.data)
    );
  }
  getStripePlans=async (data:{secretKey: string}): Promise<any> => {
    return handleAsync(() =>
      axiosInstance.post(`builder/get_stripe_plans`, data
      ).then(res => res.data)
    );
  }
  createStripePlan=async (data:{secretKey: string, planName: string, amount: number, currency: string, interval: 'month' | 'year', credit: number}): Promise<any> => {
    return handleAsync(() =>
      axiosInstance.post(`builder/create_stripe_plan`, data
      ).then(res => res.data)
    );
  }
  deleteStripePlan=async (data:{secretKey: string, priceId: string, productId: string}): Promise<any> => {
    return handleAsync(() =>
      axiosInstance.post(`builder/delete_stripe_plan`, data
      ).then(res => res.data)
    );
  }
  stripeBillingPortal=async (data:{secretKey: string, customerId: string, returnUrl: string,appId:string}): Promise<any> => {
    return handleAsync(() =>
      axiosInstance.post(`builder/billing-portal`, data
      ).then(res => res.data)
    );
  }
  updateStripePlan=async (data:{secretKey: string, productId: string, credit: number}): Promise<any> => {
    return handleAsync(() =>
      axiosInstance.post(`builder/update_stripe_plan`, data
      ).then(res => res.data)
    );
  }
  retrieveStripeSession=async (sessionId:string,secretkey:string): Promise<any> => {
    return handleAsync(() =>
      axiosInstance.get(`builder/retrieve_stripe_checkout_session?session_id=${sessionId}&secret_key=${encodeURIComponent(secretkey)}`
      ).then(res => res.data)
    );
  }
  saveTransactionDetails= async(key: string, token: string, appId: string, description: string, currency: string, amount: string, quantity: number, paymentMethod:string, paymentStatus?:string, email?:string, loginMode?:boolean, creditOnPurchase?:number, subscriptionData?:{subscription_id?: string, current_period_end?: number, interval?: string, product_id?: string, product_name?: string}): Promise<any>=> {
    return handleAsync(() =>
      axiosInstance.post(`builder/save_transaction_details`,{ key, token, appId, description, currency, amount, quantity, paymentMethod, paymentStatus: paymentStatus ? paymentStatus : '' , email : email ? email :'', loginMode: loginMode ? loginMode : false, creditOnPurchase: creditOnPurchase !== undefined ? creditOnPurchase : null, subscriptionData: subscriptionData || null}
      ).then(res => res.data)
    );
  }

  signup = async (email: string): Promise<any> => {
    return handleAsync(() =>
      axiosInstance.post(`builder/signup`, { email })
      ).then(res => res.data)
      .catch(error => {
        console.log("signup error:", error);
        return false;
      })
  }
  // Add this method to your FrontendService class
  verifyEmailToken = (token: string,invitationType:string): Promise<any> => {
    return handleAsync(() =>
      axiosInstance.get(`builder/verifyEmailToken/${token}/${invitationType}`)
      ).then(res => res.data)
  };

 
  login = async (email: string, password: string): Promise<any> => {
        const response = await axiosInstance.post(`builder/login`, { email, password });
        return response.data; 
  };


  loginWithGoogle = async (token: string) => {
    console.log("Sending token to backend:", token); // Debug log
    const response = await axiosInstance.post('builder/auth/google', { credential:  token });
    console.log("Response from backend:", response.data); // Debug log
    return response.data;
  };
  forgotPassword = async (email:string):Promise <any> =>{
    // return handleAsync(() =>
    //   axiosInstance.post(`builder/forgotPassword`, { email}
    //   ).then(res => res.data)
    // );
    const response = await axiosInstance.post(`builder/forgotPassword`, { email});
        return response.data; 
  };
  resetPassword = async(token: string, password: string): Promise<any> => {
    return handleAsync(() =>
      axiosInstance.post(`builder/resetPassword`, { 
        token,
        password 
      })
    ).then(res => {
      if (res && res.data) {
        return {
          success: true,
          data: res.data
        };
      }
      return {
        success: false,
        message: 'Failed to reset password'
      };
    }).catch(error => {
      console.log("Reset password error:", error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to reset password'
      };
    });
  };


  // Keep POST for resend as it's modifying server state
  resendVerificationEmail = (email: string): Promise<any> => {
    return handleAsync(() =>
      axiosInstance.post(`builder/resendVerification`, { email })
      ).then(res => res.data)
  };


  logoutUser= async(): Promise<any>=> {
    return handleAsync(() =>
      axiosInstance.post(`builder/logout`,{}
      ).then(res => res.data)
    );
  }

  updateUserDetails = async (data: { email: string, name?: string, companyName?: string }): Promise<any> => {
    return handleAsync(() =>
      axiosInstance.post('builder/update_userDetails', data)
    ).then(res => {
      return res.data;
    })
    .catch(error => {
      console.error('Error updating user details:', error);
      throw error;
    });
  };

  updateUserPassword = async (data: { email: string, oldPassword: string, newPassword: string }): Promise<any> => {
    try {
      const res = await axiosInstance.post('builder/update_userPassword', data);
      return res.data;
    } catch (error: any) {
     
      if (error.response && error.response.data) {
        return error.response.data;
      }
     
      return {
        success: false,
        message: 'Network or unexpected error',
        data: null,
        error: error.message
      };
    }
  };

  generateAIImage = async (data: any): Promise<any> => {
    try {
      const res = await axiosInstance.post(`builder/ai_image_generator`, { ...data });
      return res.data;
    } catch (err: any) {
      if (err.response && err.response.data) {
        return {
          success: false,
          message: err.response.data.message || "Error generating image",
          error: err.response.data.error ,
        };
      }

      return {
        success: false,
        message: "Network error",
        error: err.message ,
      };
    }
  };
  aIImageEditor = async (formData: any): Promise<any> => {
    try {
      const res = await axiosInstance.post(`builder/ai_image_editor`,formData,{
        headers:{
          'Content-Type': 'multipart/form-data'
        }
      });
      return res.data;
    } catch (err: any) {
      if (err.response && err.response.data) {
        return {
          success: false,
          message: err.response.data.message || "Error generating image",
          error: err.response.data.error,
        };
      }

      return {
        success: false,
        message: "Network error",
        error: err.message,
      };
    }
  };
  leftAgentCreditLimit = async (): Promise<any> => {
    const response = await axiosInstance.get(`builder/agent_left_credit`,);
    return response.data; 
};
checkSessionValidity = async (): Promise<any> => {
  const response = await axiosInstance.get(`builder/check-token`);
  return response;
};

generateWebhook = async(data:{url:string, appId:string, secretKey:string, webHookKeyId:string}):Promise<any> =>{
    return handleAsync(() =>
      axiosInstance.post(`builder/create_webhook_secret`, data
      ).then(res => res.data)
    );
}
}
export default BuilderService;
